import { render, staticRenderFns } from "./paso1.vue?vue&type=template&id=3c2c4c9d&scoped=true&"
import script from "./paso1.vue?vue&type=script&lang=ts&"
export * from "./paso1.vue?vue&type=script&lang=ts&"
import style0 from "./paso1.vue?vue&type=style&index=0&id=3c2c4c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c4c9d",
  null
  
)

export default component.exports